import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
const SvgLargeChevronDown = (props, ref) => (_jsx("svg", { width: 32, height: 10, viewBox: "0 0 32 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: _jsx("path", { id: "Icon", d: "M2 2L16 8L30 2", stroke: "currentColor", strokeOpacity: 0.3, strokeWidth: 2.66667, strokeLinecap: "round", strokeLinejoin: "round" }) }));
const ForwardRef = forwardRef(SvgLargeChevronDown);
export default ForwardRef;
